import { AppDispatch } from "../store";
import { setNotification } from "../store/toastNotifications";
import { EmployeeTransport } from "../types/ganttChart";
import api, { API_PATHS } from "./api";

class EmployeeSettingsService {
  static async editEmployeeWorkTime(
    shiftId: number,
    workTimeStart: string,
    workTimeEnd: string,
    dispatch: AppDispatch,
  ) {
    try {
      await api.post(API_PATHS.updateEmployeeWorkTime, null, {
        params: { shiftId, workTimeStart, workTimeEnd },
      });
    } catch (error: any) {
      dispatch(setNotification({ message: error.message }));
      throw new Error(error.message);
    }
  }

  static async editTransportSegments(
    shiftId: number,
    segments: EmployeeTransport[],
    dispatch: AppDispatch,
  ) {
    try {
      await api.post(
        API_PATHS.editTransportSegments,
        { segments },
        { params: { shiftId } },
      );
    } catch (error: any) {
      dispatch(setNotification({ message: error.message }));
      throw new Error(error.message);
    }
  }

  static async deleteEmployeeWorkTime(shiftId: number, dispatch: AppDispatch) {
    try {
      await api.post(API_PATHS.deleteEmployeeWorkTime, null, {
        params: { shiftId },
      });
    } catch (error: any) {
      dispatch(setNotification({ message: error.message }));
      throw new Error(error.message);
    }
  }

  static async clearTransportSegments(
    shiftId: number,
    dispatch: AppDispatch,
  ) {
    try {
      await api.post(API_PATHS.clearTransportSegments, null, {
        params: { shiftId },
      });
    } catch (error: any) {
      dispatch(setNotification({ message: error.message }));
      throw new Error(error.message);
    }
  }
}

export default EmployeeSettingsService;
